<template>
  <div class="flex justify-center items-center origin-top-left !pointer-events-none" :class="$style.container">
    <component
        :is="widgetComponent"
        class="!pointer-events-none"
        :widget="formattedWidget"
        :target-step-index="targetStepIndex"/>
  </div>
</template>

<script>
import ColumnWidgetComponent from '@components/Widgets/ColumnWidget/ColumnStepPreview/ColumnStepPreview.vue'
import ImageColumnStepPreview
  from '@components/Widgets/ImageColumnWidget/ImageColumnStepPreview/ImageColumnStepPreview.vue'
import FortuneWheelStepPreview
  from '@components/Widgets/FortuneWheelWidget/FortuneWheelStepPreview/FortuneWheelStepPreview.vue'
import { formatWidgetForApi } from '@utils/formatWidgetApi'

export default {
  name: 'WidgetStepPreview',
  components: {
    ColumnWidgetComponent,
    ImageColumnStepPreview,
    FortuneWheelStepPreview,
  },
  props: {
    widget: {
      required: true,
      type: Object,
    },
    targetStepIndex: {
      required: false,
      type: Number,
      default: 0,
    },
    needsReformatting: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedWidget() {
      return this.needsReformatting ? formatWidgetForApi(this.widget) : this.widget
    },
    widgetComponent() {
      if (!this.widget) return null

      const typeComponentMap = {
        column: 'ColumnWidgetComponent',
        imageColumn: 'ImageColumnStepPreview',
        fortuneWheel: 'FortuneWheelStepPreview',
      }

      return typeComponentMap[this.widget.type] || null
    },
  },
}
</script>

<style lang="scss" module>
.container {
  min-width: 1024px;
  min-height: 620px;
  transform: scale(0.12);
}
</style>